import React from 'react';
import { Paper } from '@material-ui/core';
import Menu from '../../navigationMenu/navigationMenu';

const NavigationMenu = () => {
  return (
    <Paper elevation={0}>
      <Menu mobile={true} />
    </Paper>
  );
};

export default NavigationMenu;
